import { useQuery, useMutation, useQueryClient } from '@tanstack/react-query';
import { toast } from 'react-toastify';
import { parentLogin, parentLogout } from '../parentApi';
import {
  clearCurrentChild,
  getCurrentChild,
  getParent,
  getParentChildren,
  parentForgotPassword,
  parentResetPassword,
  setCurrentChild,
} from './parentDashboardApi';

export const useGetParent = (parentId) => {
  return useQuery({
    queryKey: ['parent', parentId],
    queryFn: () => getParent(parentId),
    enabled: !!parentId,
  });
};

export const useParentLogin = () => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationKey: ['parent_login'],
    mutationFn: parentLogin,
    onSuccess: (data) => {
      // queryClient.setQueryData(['parent'], data);
      queryClient.invalidateQueries({ queryKey: ['parent'] });
      queryClient.invalidateQueries({
        queryKey: ['parentChildren', `${data._id}`],
      });
      // Todo: Might be a good place to do something with logged in parent data
      toast.success('Successfully logged in!');
    },
    onError: (error) => {
      console.error('Login error:', error);
      toast.error(error.response?.data?.message || 'Failed to login');
    },
  });
};

export const useParentForgotPassword = () => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationKey: ['parent/forgotpassword'],
    mutationFn: parentForgotPassword,
    onSuccess: (data) => {
      queryClient.setQueryData(['parentForgotPassword'], data);
      toast.success('Email sent! Check your inbox for further instuctions.');
    },
    onError: (error) => {
      console.error('Forgot Password error:', error);
      toast.error(error.response?.data?.message || 'Reset Password Failed');
    },
  });
};

export const useGetParentChildren = (parentId) => {
  return useQuery({
    queryKey: ['parentChildren', parentId],
    queryFn: () => getParentChildren(parentId),
    // Only run the query if there's a parentId
    enabled: !!parentId,
    initialData: [],
    staleTime: 0,
  });
};
export const useParentResetPassword = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationKey: ['parent/resetpassword'],
    mutationFn: parentResetPassword,
    onSuccess: (data) => {
      queryClient.setQueryData(['passwordReset'], data);
      toast.success('Password reset successful!');
    },
    onError: (error) => {
      console.error('Password reset error:', error);
      toast.error(error.response?.data?.message || 'Failed to reset password');
    },
  });
};

export const useParentLogout = () => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationKey: ['parent_logout'],
    mutationFn: parentLogout,
    onSuccess: () => {
      queryClient.removeQueries(['parent']);
      toast.success('Successfully logged out!');
    },
    onError: (error) => {
      console.error('Logout error:', error);
      toast.error(error.response?.data?.message || 'Failed to logout');
    },
  });
};

export const useGetCurrentChild = () => {
  return useQuery({
    queryKey: ['currentChild'],
    queryFn: getCurrentChild,
  });
};

export const useSetCurrentChild = () => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: setCurrentChild,
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['currentChild'] });
    },
  });
};

export const useRemoveCurrentChild = () => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: clearCurrentChild,
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['currentChild'] });
    },
  });
};
